import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { momentInUTC, localFullDateLong } from 'utils/LocalDateTimeHelper';

import { load } from '../reducers/naps';

@standardAsyncConnect([
  {
    dispatch: () => load(),
    state: state => ({naps: state.horseRacing.naps.napsList})
  }
])
@catchLifeCycleErrors
export default class NapsTable extends Component {
  static propTypes = {
    naps: PropTypes.array
  };

  render() {
    require('./NapsTable.scss');

    const errorPixelSrc = `/1x1.gif?type=naps-table&id=0&cb=${Date.now()}`;

    return (
      <div className="horse-racing-naps-table">
        <h1 className="page-main-title">Naps Table <small>{localFullDateLong(momentInUTC())}</small></h1>
        <section className="horse-racing-naps-table-content">
          {(this.props.naps && this.props.naps.length > 0) ?
            <table className="naps-table">
              <thead>
                <tr>
                  <th>SELECTION</th>
                  <th className="race-name-column">RACE</th>
                  <th>TIPSTER</th>
                  <th>W</th>
                  <th>L</th>
                  <th>£1 STAKE</th>
                </tr>
              </thead>
              <tbody>
                { this.props.naps.map(nap => {
                    return (
                      <tr key={nap.tipster + nap.tipsterSource}>
                        <td>
                          <div className="horse-name">{nap.horseName}</div>
                          <div className="race-name-selection-cell">{nap.race}</div>
                        </td>
                        <td className="race-name-column">{nap.race}</td>
                        <td>
                          <div className="tipster-source">{nap.tipsterSource}</div>
                          <div className="tipster">{nap.tipster}</div>
                        </td>
                        <td>{nap.wins}</td>
                        <td>{nap.losses}</td>
                        <td>{nap.stake}</td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
              :
              <div>
              <p className="no-naps-msg">Today's Naps Table is currently unavailable. Please check back later.</p>
              <div> <img src={errorPixelSrc} width="1" height="1" /> </div>
              </div>
            }
          </section>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/NapsTable.js